export default {
  methods: {
    validIssueWeight() {
      return false;
    },
    filterByWeight() {},
  },
};
